module.exports = __webpack_public_path__ + "media/guizhou.b97b4910.mp4";